import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import DatePicker from "../component/DatePicker.js";

const DateConditions = ({
    startDate,
    currentDate,
    endDate,
    handleStartDateChange,
    handleCurrentDateChange,
    handleEndDateChange,
    handlePrevDay,
    handleNextDay,
    ...props
}) => {
    const DatePickerStyle = {
        width: props.disabledStartEnd ? "105px" : "130px",
        flex: 'none',
        "& .MuiButtonBase-root": {
            p: 0,
        },
        "& .MuiInputBase-root": {
            flexDirection: "row-reverse",
        },
        "& .MuiSvgIcon-root": {
            display: props.disabledStartEnd ? "none" : "black",
            color: "#333",
        },
        "& .MuiInputBase-input": {
            pt: 0.5,
            pb: 0.5,
            color: "#333",
            fontWeight: 600,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            display: "none",
        },
    };

    const centerDatePickerStyle = {
        width: "120px",
        flex: 'none',
        "& .MuiIconButton-root": {
            pl: 0
        },
        "& .MuiSvgIcon-root": {
            color: "#333",
        },
        "& .MuiInputBase-input": {
            pt: 0.5,
            pb: 0.5,
            color: "#C00F0C",
            fontWeight: 600,
        },
    };

    return (
        <Box display="flex" alignItems="center">
            <Typography variant="subtitle1" sx={{ whiteSpace: "nowrap" }}>
                {props.text || 'Schedule Selection:'}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    disabled={props.disabledStartEnd}
                    value={startDate}
                    onChange={handleStartDateChange}
                    format="DD MMM YYYY"
                    renderInput={(params) => <TextField {...params} />}
                    sx={DatePickerStyle}
                />
                <img src="assets/illustrations/linecircle.svg" alt="lineCircle" style={{ transform: "rotate(180deg)" }} />
                <img
                    src="assets/buttons/doublearrow.svg"
                    alt="arrowDiv"
                    onClick={handlePrevDay}
                    style={{ cursor: "pointer", marginRight: "8px" }}
                />
                <DatePicker
                    value={currentDate}
                    onChange={handleCurrentDateChange}
                    format="DD/MM/YYYY"
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            inputProps={{
                                ...params.inputProps,
                                min: startDate.format("DD/MM/YYYY"),
                                max: endDate.format("DD/MM/YYYY"),
                            }}
                        />
                    )}
                    minDate={startDate || dayjs().startOf("day")}
                    maxDate={endDate || dayjs().add(1, "month").endOf("day")}
                    sx={centerDatePickerStyle}
                    inputFormat="DD/MM/YYYY"
                />
                <img
                    src="assets/buttons/doublearrow.svg"
                    alt="arrowDiv"
                    onClick={handleNextDay}
                    style={{ transform: "rotate(180deg)", cursor: "pointer", marginLeft: "8px" }}
                />
                <img src="assets/illustrations/linecircle.svg" alt="lineCircle" />
                <DatePicker
                    disabled={props.disabledStartEnd}
                    value={endDate}
                    onChange={handleEndDateChange}
                    format="DD MMM YYYY"
                    renderInput={(params) => <TextField {...params} />}
                    minDate={startDate ? startDate.add(2, "month").startOf("day") : dayjs().startOf("day")}
                    sx={DatePickerStyle}
                />
            </LocalizationProvider>
        </Box>
    )
};

export default DateConditions;